<script setup lang="ts">
import Checkbox from '@/components/Shared/Input/Checkbox/Checkbox.vue';
import BusinessSvg from '@/assets/svg/business-20.svg?component';
import AlertTriangleIcon from '@/assets/svg/shared/alert-triangle.svg?component';
import { computed } from 'vue';

const props = defineProps<{
  companyName: string;
  modelValue: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const isDisabled = computed(() => props.disabled === true);
</script>

<template>
  <div class="flex flex-col">
    <div class="flex items-center">
      <!-- Company Name-->
      <div class="flex rounded bg-tint-20 px-3 py-2.5">
        <BusinessSvg class="fill-shade-800" />
        <span class="ml-2.5 text-sm font-bold text-shade-800">{{ companyName }}</span>
      </div>

      <!-- Keep Name Confidential Checkbox -->
      <div class="ml-3 flex items-center" :class="{ 'opacity-85': isDisabled }">
        <Checkbox
          :model-value="modelValue"
          @update:model-value="emit('update:modelValue', $event)"
          :disabled="isDisabled"
        />
        <span class="ml-2 text-xs">Keep company name confidential</span>
      </div>
    </div>

    <div aria-live="polite">
      <div
        v-if="modelValue"
        class="mt-2 flex gap-2 rounded-xl border border-solid border-caution-100 bg-caution-0 px-4 py-3"
        data-test="confidential-name-warning"
      >
        <AlertTriangleIcon
          aria-hidden="true"
          class="-mt-0.5 h-5 w-5 shrink-0 overflow-visible text-caution-600"
        />
        <p class="text-sm leading-[21px] text-caution-800">
          <span class="font-bold text-caution-900">This may reduce applicant flow.</span>
          Confidential jobs get limited job-board visibility.
        </p>
      </div>
    </div>
  </div>
</template>
